import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

let cachedSlots = null;
let fetchPromise = null;

async function fetchTutorials() {
  if (cachedSlots) return cachedSlots;
  if (fetchPromise) return fetchPromise;

  fetchPromise = axios.get('/api/tutorials/')
    .then(res => {
      cachedSlots = res.data;
      return cachedSlots;
    })
    .catch(() => {
      cachedSlots = [];
      return cachedSlots;
    })
    .finally(() => {
      fetchPromise = null;
    });

  return fetchPromise;
}

export function useTutorials() {
  const [slots, setSlots] = useState(cachedSlots || []);
  const [loading, setLoading] = useState(!cachedSlots);

  useEffect(() => {
    if (cachedSlots) {
      setSlots(cachedSlots);
      setLoading(false);
      return;
    }

    fetchTutorials().then(data => {
      setSlots(data);
      setLoading(false);
    });
  }, []);

  const getSlotVideo = useCallback((slotKey) => {
    return slots.find(s => s.slot_key === slotKey) || null;
  }, [slots]);

  return { slots, loading, getSlotVideo };
}
